import { render, staticRenderFns } from "./ManageGroupsPage.vue?vue&type=template&id=5e65154a&scoped=true&"
import script from "./ManageGroupsPage.vue?vue&type=script&lang=js&"
export * from "./ManageGroupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e65154a",
  null
  
)

export default component.exports